import type { ReactNode } from "react";
import HomeLogo from "./HomeLogo";
import Icon from "./Icon";

export default function BackHeader({
  title,
  onBack,
  titleClass = "",
  action,
  logo = false,
}: {
  title: string;
  /** Omit when there is nowhere to go back to (the read-only Scheduler). */
  onBack?: () => void;
  titleClass?: string;
  action?: ReactNode;
  /** Soulcake's logo, linking to main.soulcake.eu, centred between the title and the action. It only shows when it
   *  fits there: on a narrow phone the title and buttons keep the room. */
  logo?: boolean;
}) {
  return (
    <header className="flex items-center gap-2.5">
      {onBack && (
        <button
          onClick={onBack}
          aria-label="Back"
          className="flex size-10 shrink-0 items-center justify-center rounded-full bg-blush text-rose-ink transition-colors active:bg-[#f8d7dd]"
        >
          <Icon name="back" size={22} />
        </button>
      )}
      <h1 className={`min-w-0 truncate text-[22px] font-bold tracking-[-0.02em] ${logo ? "" : "flex-1"} ${titleClass || "text-[#3a1c25]"}`}>{title}</h1>
      {logo && (
        // The negative margin takes back the header's gap, so an empty slot costs the title nothing.
        <div className="@container -ml-2.5 flex min-w-0 flex-1 justify-center">
          <HomeLogo className="hidden @min-[84px]:block" />
        </div>
      )}
      {action}
    </header>
  );
}
